import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { clearAuth } from '@/lib/auth';
import { useRouter } from '@tanstack/react-router';
import { ROUTES } from '@/lib/constants';
export function useLogout() {
    const queryClient = useQueryClient();
    const router = useRouter();
    return useMutation({
        mutationFn: () => apiClient('/auth/logout', { method: 'POST' }),
        onSettled: () => {
            clearAuth();
            queryClient.clear();
            void router.navigate({ to: ROUTES.LOGIN });
        },
    });
}
//# sourceMappingURL=useLogout.js.map